module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Medium-WebS.7043d421.eot";